import { fetchApiData, PIC } from '../Internals';
;
export function parseContextArrDisp(iContext, iOptions) {
    let resContextArr = [];
    if (iContext)
        iContext.forEach(cLine => {
            var _a, _b, _c;
            if (cLine.eventFncKey) {
                if (cLine.eventFncKey === 'loadPage') {
                    let extra = '';
                    if (iOptions.extraParms) {
                        iOptions.extraParms.forEach(ep => {
                            extra += `%02${ep.key}%04${ep.val}`;
                        });
                    }
                    //@ts-ignore
                    cLine.eventFnc = () => { loadPage(cLine.eventTxt.split(',')[0], cLine.eventTxt.split(',')[1] + extra); };
                }
                else if (cLine.eventFncKey === 'apiRequest') {
                    let data = {};
                    let tmp = cLine.eventTxt.split(',');
                    let target = tmp[0];
                    if (tmp.length > 1) {
                        let propArr = (_b = (_a = tmp[1]) === null || _a === void 0 ? void 0 : _a.split('$')) !== null && _b !== void 0 ? _b : [];
                        /* replace placeholders with values from current order */
                        propArr.forEach(prop => {
                            if (prop.length !== 0) {
                                let innerPropArr = prop.substring(prop.indexOf('{') + 1, prop.indexOf('}')).split('|');
                                let key = innerPropArr[0], val;
                                if (innerPropArr.length > 1) {
                                    val = innerPropArr[1];
                                }
                                else if (iOptions.iOrder) {
                                    //@ts-ignore
                                    val = iOptions.iOrder[key];
                                }
                                else {
                                    val = '';
                                }
                                if (key && ['actNo', 'seqNo', 'value'].includes(key)) {
                                    val = parseInt(val);
                                }
                                //@ts-ignore
                                data[key] = val;
                            }
                        });
                        //@ts-ignore
                        data['termName'] = (_c = iOptions.dispRef) === null || _c === void 0 ? void 0 : _c.globVars.termName;
                    }
                    let opts = {
                        systemId: PIC.systemId,
                        postBody: {
                            mode: target,
                            data: data
                        }
                    };
                    cLine.eventFnc = () => {
                        return fetchApiData('/toms/spedition/speditionapi', opts).then((data) => {
                            if (data && data[0] && data[0].result) {
                                if (data[0].result == 200) {
                                    console.log('APIREQ went well');
                                    /*if(data[0].globVars) iOptions.callBackFunction({data: data[0], dispRef: iOptions.dispRef});
                                    else */ iOptions.callBackFunction({ dispRef: iOptions.dispRef });
                                }
                                else if (data[0].result == 400) {
                                    console.log('400?');
                                }
                                else {
                                    console.log(data);
                                    alert('API returned ' + data[0].result + ' handling is not implemented.');
                                }
                            }
                            else {
                                console.log('caught by safety');
                            }
                        });
                    };
                }
            }
            resContextArr.push(cLine);
        });
    if (!(resContextArr.length > 0))
        resContextArr = iContext;
    return resContextArr;
}
//# sourceMappingURL=PICDispatchInterfaces.js.map